import { Button } from '@/components/Buttons';
import { TIconName } from '@/design-tokens/icons';
import { cn } from '@/utils/cn';
import React from 'react';

export interface PopoverButtonProps {
  active: boolean;
  ariaLabel: string;
  iconLeft: TIconName;
  onClick: () => void;
  title: string;
}

/**
 * Reusable icon-only trigger button used by PageHeader popover menus.
 */
export const PopoverButton: React.FC<PopoverButtonProps> = ({
  active,
  ariaLabel,
  iconLeft,
  onClick,
  title,
}) => {
  return (
    <Button
      aria-label={ariaLabel}
      className={cn('h-8 w-8', active ? 'bg-neutral-white' : 'bg-neutral-gray-100')}
      color="var(--color-brand-primary)"
      iconLeft={iconLeft}
      iconOnly={true}
      iconSizeOverride={18}
      onClick={onClick}
      size="small"
      title={title}
      variant="tertiary"
    />
  );
};

PopoverButton.displayName = 'PopoverButton';

export default PopoverButton;
